import { useTranslator } from '@bluebeam/react-i18n';
import OverlaySection from 'components/Overlays/OverlaySection';
import React from 'react';
import { useViewRfiMachine } from './ViewRFIMachine';

const ViewReqBySection: React.FC = () => {
  const { translate } = useTranslator(['mapView']);
  const { viewRfiMachineState } = useViewRfiMachine();
  const { rfi } = viewRfiMachineState.context;

  return (
    <OverlaySection label={translate('mapView:viewReqBySection.requestedBy')}>
      {rfi.submittingname.length > 0 ? (
        <div className="truncate">{rfi.submittingname}</div>
      ) : null}
      {rfi.submittingemail.length > 0 ? (
        <div className="truncate">{rfi.submittingemail}</div>
      ) : null}
      {rfi.submittingcompany.length > 0 ? (
        <div className="truncate">{rfi.submittingcompany}</div>
      ) : null}
    </OverlaySection>
  );
};

export default ViewReqBySection;
